import React, { Component } from 'react'
import { Collapse, Row, Col, Calendar } from 'hljd'
import { observer } from 'mobx-react'
import Styles from './style.module.less'
import store from './store'
import myStore from '../Search/store'
import List from './List'
import { toJS } from 'mobx'
import moment from 'moment'
const Panel = Collapse.Panel
moment.locale('zh-cn')

@observer
export default class extends Component {
  //日历标记
  dateCellRender = key => value => {
    let itemColor = store.getCalendarInfo(key, value)
    return itemColor.map((item, index) => (
      <span key={index} className={`event-${item.type}`}>
        ●
      </span>
    ))
  }
  //获取点击日期数据和宴会厅id
  onPanelChange = key => value => {
    store.setDate(key, value)
  }
  //根据选择的月份转换成日历识别的日期
  getDate(value) {
    let date = []
    const { year } = myStore
    switch (value) {
      case '1':
        date[0] = year + '-01-01'
        date[1] = year + '-02-01'
        date[2] = year + '-03-01'
        break
      case '2':
        date[0] = year + '-04-01'
        date[1] = year + '-05-01'
        date[2] = year + '-06-01'
        break
      case '3':
        date[0] = year + '-07-01'
        date[1] = year + '-08-01'
        date[2] = year + '-09-01'
        break
      case '4':
        date[0] = year + '-10-01'
        date[1] = year + '-11-01'
        date[2] = year + '-12-01'
        break
      default:
        break
    }
    return date
  }
  render() {
    const { list } = myStore
    let listData = toJS(list)
    const { months } = myStore
    let body = []
    let header
    let entity = store.getEntity()
    for (let key in listData) {
      if (entity[key]) {
        header = [
          <Row style={{ marginRight: 25 }} key={key}>
            <Col span={4} className={Styles.content}>
              {entity[key].name}
            </Col>
            <Col span={4} className={Styles.content}>
              桌数：{entity[key].max_table_num}
            </Col>
            <Col span={4} className={Styles.content}>
              最佳桌数：{entity[key].best_table_num}
            </Col>
            <Col span={4} className={Styles.content}>
              面积：{entity[key].area}㎡
            </Col>
            <Col span={4} className={Styles.content}>
              层高：{entity[key].height}m
            </Col>
          </Row>
        ]
      }
      if (key) {
        body.push(
          <Collapse
            accordion
            className={Styles.calendar_wrap}
            style={{ marginBottom: 30 }}
            key={key}
          >
            <Panel header={header}>
              <div className={Styles.calendar}>
                <Calendar
                  fullscreen={false}
                  dateCellRender={this.dateCellRender(key)}
                  onChange={this.onPanelChange(key)}
                  value={moment(this.getDate(months)[0], 'YYYY-MM')}
                />
              </div>
              <div className={Styles.calendar}>
                <Calendar
                  fullscreen={false}
                  dateCellRender={this.dateCellRender(key)}
                  onChange={this.onPanelChange(key)}
                  value={moment(this.getDate(months)[1], 'YYYY-MM')}
                />
              </div>
              <div className={Styles.calendar}>
                <Calendar
                  fullscreen={false}
                  dateCellRender={this.dateCellRender(key)}
                  onChange={this.onPanelChange(key)}
                  value={moment(this.getDate(months)[2], 'YYYY-MM')}
                />
              </div>
              <div
                style={{ height: 40, textAlign: 'center', lineHeight: '60px' }}
              >
                <span className={Styles.icon_lunch}>午市已订</span>
                <span className={Styles.icon_dinner}>晚市已订</span>
                {/*<span className={Styles.icon_all}>午晚市已订完</span>*/}
              </div>
            </Panel>
          </Collapse>
        )
      }
    }
    return (
      <div style={{ padding: '0 40px', marginTop: 20 }}>
        {body}
        <List />
      </div>
    )
  }
}
